export default "__VITE_ASSET__COIjg$Pj__"